import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_1 } from 'nove8/cohorts/stylio_1/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_PLUS } from 'nove8/cohorts/stylio_plus/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS2 } from 'nove8/cohorts/stylio_snrs2/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE2 } from 'nove8/cohorts/stylio_capsule2/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS } from 'nove8/cohorts/stylio_snrs/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS_IO } from 'nove8/cohorts/stylio_snrs_io/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS } from 'nove8/cohorts/stylio_capmoms/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS4 } from 'nove8/cohorts/stylio_capmoms4/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE } from 'nove8/cohorts/stylio_capsule/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE3 } from 'nove8/cohorts/stylio_capsule3/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_IO } from 'nove8/cohorts/stylio_capsule_io/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSEN } from 'nove8/cohorts/stylio_capsen/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP } from 'nove8/cohorts/stylio_cmp/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP2 } from 'nove8/cohorts/stylio_cmp2/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH } from 'nove8/cohorts/stylio_arch/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_IO } from 'nove8/cohorts/stylio_arch_io/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_HUSAP } from 'nove8/cohorts/stylio_husap/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_61 } from 'nove8/cohorts/stylio_capsule_61/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_71 } from 'nove8/cohorts/stylio_capsule_71/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_81 } from 'nove8/cohorts/stylio_capsule_81/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_61 } from 'nove8/cohorts/stylio_arch_61/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_71 } from 'nove8/cohorts/stylio_arch_71/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_81 } from 'nove8/cohorts/stylio_arch_81/constants/pages-configs-map'
import { PageId } from './pages'

export const ID_TO_PAGE_CONFIG_MAP: TIdToPageConfigMap = {
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS2,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE2,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS_IO,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS4,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE3,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_IO,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSEN,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP2,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_IO,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_HUSAP,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_1,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_PLUS,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_61,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_71,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE_81,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_61,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_71,
  ...ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_81,
  // Shared across the new-subscription cohorts: deliberately excluded from
  // every per-cohort config map, so it has to live here.
  [PageId.ACCOUNT_NOVE8]: {
    id: PageId.ACCOUNT_NOVE8,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
